import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Home, FileQuestion } from 'lucide-react';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center p-8 text-center">
      <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800">
        <FileQuestion className="h-10 w-10 text-gray-400" />
      </div>
      <h1 className="mb-2 text-3xl font-bold text-gray-900 dark:text-gray-100">404</h1>
      <p className="mb-2 text-xl font-semibold text-gray-700 dark:text-gray-300">
        {t('errors.notFound')}
      </p>
      <p className="mb-8 max-w-md text-sm text-gray-500 dark:text-gray-400">
        {t('errors.notFoundDescription')}
      </p>
      <Link to="/" className="btn-primary inline-flex items-center gap-2">
        <Home className="h-4 w-4" />
        {t('errors.goHome')}
      </Link>
    </div>
  );
}
